import { Component, OnInit, Input } from '@angular/core';
import { Delivery } from 'my-lib-sanfelici';



@Component({
  selector: 'app-delivery-view',
  templateUrl: './delivery-view.component.html',
  styleUrls: ['./delivery-view.component.css']
})
export class DeliveryViewComponent implements OnInit {
@Input() delivery: Delivery;
  constructor() { }

  ngOnInit() {
  }

}
